import { render, staticRenderFns } from "./TranslationAgencies.vue?vue&type=template&id=d9a0aa26&scoped=true"
import script from "./TranslationAgencies.vue?vue&type=script&lang=js"
export * from "./TranslationAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0aa26",
  null
  
)

export default component.exports